module.exports = __webpack_public_path__ + "img/UsgsBlackSymbol.efa782ef.svg";